<app-page-header title="Home" titleLink="/reports" active_item="Comissões">
</app-page-header>
<form [formGroup]="comissao">
  <div class="row">
    <h5>{{ "common.commissions" | translate }}</h5>
    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
              ><i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i
            ></a>
          </div>
        </div>
        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.initialDate" | translate }}
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #startText
                    matInput
                    [matDatepicker]="pickerIni"
                    placeholder="DD/MM/YYYY"
                    [formControl]="comissao.controls.initialDate"
                    (blur)="parseDateInput('initialDate', startText.value)"
                    (keydown.enter)="
                      parseDateInput('initialDate', startText.value)
                    "
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerIni"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerIni startView="month"></mat-datepicker>
                </mat-form-field>
                <div class="invalid-feedback">
                  {{ "common.initialDateRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="inputInitialDate" class="form-label">
                  {{ "common.finalDate" | translate }}
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #endText
                    matInput
                    [matDatepicker]="pickerFim"
                    placeholder="DD/MM/YYYY"
                    [formControl]="comissao.controls.endDate"
                    (blur)="parseDateInput('endDate', endText.value)"
                    (keydown.enter)="parseDateInput('endDate', endText.value)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerFim"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerFim startView="month"></mat-datepicker>
                </mat-form-field>
                <div class="invalid-feedback">
                  {{ "common.finalDateRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDescricao" class="form-label">{{
                  "common.client" | translate
                }}</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    name="descricao"
                    id="txtDescricao"
                    bindValue="value"
                    [formControl]="comissao.controls.responsavel"
                  />
                  <i class="fe fe-copy input-icon" (click)="paste()"></i>
                </div>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar()"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div class="card rounded-10 shadow">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.depositTotal" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">
                    {{ totalDeposito | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                    "common.depositCount" | translate
                  }}</span>
                  <p class="fs-15 me-3 mb-0">{{ qtDeposito }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-down"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.withdrawalTotal" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ totalSaque | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-down"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.withdrawalCount" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ qtSaque }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-up text-primary"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">{{
                      "common.totalCommissions" | translate
                    }}</span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ totalComissao | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.history" | translate }}</div>
          <div class="card-options">
          </div>
        </div>
        <div class="card-body button-table">
          <app-table-transactions-commissions
            #table
            (transactionsLoaded)="onTransactionsLoaded($event)"
          >
          </app-table-transactions-commissions>
        </div>
      </div>
    </div>
  </div>
</form>
